import logo from './LogoIcon.svg';

export const LogoIcon = () => <img src={logo} alt="Quasar" height={28} />;
